<script lang="ts">
	import { fade } from "svelte/transition";
	import Header from "./Header.svelte";
	import { Board } from "./board";
	import Keyboard from "./keyboard";
	import Modal from "./Modal.svelte";
	import { getContext, onMount, setContext } from "svelte";
	import Settings from "./settings";
	import {
		// Share,
		// Seperator,
		Definition,
		Tutorial,
		Statistics,
		// Distribution,
		Timer,
		Toaster,
		// ShareGame,
		Tips,
		Welcome
	} from "./widgets";
	import {
		contractNum,
		DELAY_INCREMENT,
		PRAISE,
		getState,
		modeData,
		checkHardMode,
		ROWS,
		COLS,
		newSeed,
		createNewGame,
		words,
		searchIndiceFamille,
		searchIndiceWord,
		searchLinkProject,
		resetTuto,
	} from "../utils";
	import { letterStates, settings, mode } from "../stores";


	export let word: string;
	export let stats: Stats;
	export let game: GameState;
	export let toaster: Toaster;

	setContext("toaster", toaster);
	const version = getContext<string>("version");

	// implement transition delay on keys
	const delay = DELAY_INCREMENT * ROWS + 800;

	let showTutorial = $settings.tutorial === 3;
	let showWelcome = $settings.welcome === 3;
	let showSettings = false;
	let showStats = false;
	let showRefresh = false;

	let board: Board;
	let timer: Timer;
	let tips: Tips;

	let tip = 0;
	$: if (showSettings && tips) tip = Math.floor(tips.length * Math.random());

	function submitWord() {
		// console.log(words.words)
		// console.log('est dans la liste',words.contains(game.board.words[game.guesses]))
		// console.log('LINE', game.guesses) // LINE
		if (game.board.words[game.guesses].length !== COLS) {
			toaster.pop("Pas suffisamment de lettres");
			board.shake(game.guesses);
		} else if (words.contains(game.board.words[game.guesses])) {
			if (game.guesses > 0) {
				const hm = checkHardMode(game.board, game.guesses);
				if ($settings.hard[$mode]) {
					if (hm.type === "🟩") {
						toaster.pop(
							`${contractNum(hm.pos + 1)} lettre doit être  ${hm.char.toUpperCase()}`
						);
						board.shake(game.guesses);
						return;
					} else if (hm.type === "🟨") {
						toaster.pop(`Les devinettes doivent contenir ${hm.char.toUpperCase()}`);
						board.shake(game.guesses);
						return;
					}
				} else if (hm.type !== "⬛") {
					game.validHard = false;
				}
			}
			const state = getState(word, game.board.words[game.guesses]);



			game.board.state[game.guesses] = state;
			state.forEach((e, i) => {
				const ls = $letterStates[game.board.words[game.guesses][i]];
				if (ls === "🔳" || e === "🟩") {
					$letterStates[game.board.words[game.guesses][i]] = e;
				}
			});
			++game.guesses;
			if (game.board.words[game.guesses - 1] === word) win();
			else if (game.guesses === ROWS) lose();
		} else {
			toaster.pop("Ne figure pas dans la liste des mots");
			board.shake(game.guesses);
		}
	}

	function win() {

		resetTuto();

		board.bounce(game.guesses - 1);
		game.active = false;

		setTimeout(
			// () => toaster.pop(PRAISE[game.guesses - 1]),
			() => {
				const praise_random = Math.floor(Math.random() * PRAISE.length);
				toaster.pop(PRAISE[praise_random]) 
			},
			DELAY_INCREMENT * COLS + DELAY_INCREMENT
		);
		setTimeout(setShowStatsTrue, delay * 1.4);
		if (!modeData.modes[$mode].historical) {
			++stats.guesses[game.guesses];
			++stats.played;
			if ("streak" in stats) {
				stats.streak =
					modeData.modes[$mode].seed - stats.lastGame > modeData.modes[$mode].unit
						? 1
						: stats.streak + 1;
				if (stats.streak > stats.maxStreak) stats.maxStreak = stats.streak;
			}
			stats.lastGame = modeData.modes[$mode].seed;
			localStorage.setItem(`stats-${$mode}`, JSON.stringify(stats));
		}
	}

	function lose() {
		game.active = false;
		setTimeout(setShowStatsTrue, delay);
		if (!modeData.modes[$mode].historical) {
			++stats.guesses.fail;
			++stats.played;
			if ("streak" in stats) stats.streak = 0;
			stats.lastGame = modeData.modes[$mode].seed;
			localStorage.setItem(`stats-${$mode}`, JSON.stringify(stats));
		}
	}

	function concede() {
		showSettings = false;
		setTimeout(setShowStatsTrue, DELAY_INCREMENT);
		lose();
	}

	function reload() {

		$settings.tutorial = 0;
		$settings.welcome = 0;

		modeData.modes[$mode].historical = false;
		modeData.modes[$mode].seed = newSeed($mode);
		game = createNewGame($mode);

		localStorage.setItem('reload',true);

		history.pushState("", document.title, window.location.pathname)
		location.reload();

	}

	function setShowStatsTrue() {
		if (!game.active) showStats = true;
	}

	onMount(() => {
		if (!game.active) setTimeout(setShowStatsTrue, delay);
	});
	// $: toaster.pop(word);

	// const indice = searchIndiceFamille(word);
	const indice = searchIndiceWord(word);

	



	const projectLink = searchLinkProject(word);

	if(localStorage.getItem('reloadautowin')){
		localStorage.removeItem('reloadautowin')
		setTimeout(()=>{autoWin()},400)
	}

	function autoWin(e : null){
		if(e){
			e.preventDefault();
		}
		
		const arrayWord = word.split("");
		arrayWord.forEach(key => {
			fakeK(key)
		});
		fakeK("Enter")

	}

	function autoFail(e){
		e.preventDefault();

		let arrayWord = word.split("");
		arrayWord = arrayWord.reverse();
		arrayWord[arrayWord.length-1] = "z"

		arrayWord.forEach(key => {
			fakeK(key)
		});
		fakeK("Enter")

	}
	
	setTimeout(() => {
		// autoWin();
		// autoFail();
	}, 300);

	function fakeK(keyd){
		var evt = new KeyboardEvent('keydown', { key:keyd });
		document.body.dispatchEvent(evt);
	}

	function tuto(){
		localStorage.removeItem('mode')
		localStorage.removeItem('state-0')
		localStorage.removeItem('settings')
		localStorage.removeItem('stats-0')
		localStorage.removeItem('version')

		localStorage.setItem('reload', true);

		history.pushState("", document.title, window.location.pathname)
		location.reload();
	}

	function autoReload(){
		localStorage.setItem('reload', true);
		history.pushState("", document.title, window.location.pathname)
		location.reload();
	}
	function reloadAutoWin(){
		localStorage.setItem('reloadautowin', true);
		reload();
	}


	vh();
	window.onresize = () => {
		vh();
		boardHeight();
	};
	window.onresize = () => {
		vh();
		boardHeight();
	};
	window.addEventListener('scroll', () => {
		vh();
		boardHeight();
	})

	onMount(async () => {
		boardHeight();
	});


	function vh() {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	function boardHeight() {
		const boardRow = getAbsoluteHeight(document.querySelector('.board .board-row'));
		const boardMarge = getMargeAndPadding(document.querySelector('.board'));
		const boardHeight = ( boardRow * 6 ) + boardMarge;

		document.documentElement.style.setProperty('--boardheight', `${boardHeight}px`);
	}
	function getAbsoluteHeight(el) {
		el = (typeof el === 'string') ? document.querySelector(el) : el; 

		var styles = window.getComputedStyle(el);
		var margin = parseFloat(styles['marginTop']) +
					parseFloat(styles['marginBottom']);

		return Math.ceil(el.offsetHeight + margin);
	}
	function getMargeAndPadding(el) {
		el = (typeof el === 'string') ? document.querySelector(el) : el; 

		var styles = window.getComputedStyle(el);
		var margin = parseFloat(styles['marginTop']) +
					parseFloat(styles['marginBottom']);

		var padding = parseFloat(styles['paddingTop']) +
					parseFloat(styles['paddingBottom']);
					
		return Math.ceil(padding);
	}

	const famille = localStorage.getItem("famille")

	const winSize = window.innerWidth + ' x ' + window.innerHeight;


	// console.log('indice', indice)
	// console.log('word', word)
	// console.log('projectLink', projectLink)


	// SHOW DEBUG
	
	let pass = [];
	document.onkeydown = function(e){
		pass.push(e.key)
		const w = 'caca';
		if(pass.slice(-w.length,pass.length).join('') == w){
			document.querySelector('.debug').style.cssText = 'transform: translateX(0%);opacity: 1;'
			setTimeout(()=>{
				document.querySelector('.debug').style.cssText = 'transform: translateX(110%); opacity: 0;'
			},5000)
		}
	}

</script>

<svelte:body on:click={board.hideCtx} on:contextmenu={board.hideCtx} />
<main class:guesses={game.guesses !== 0} style="--rows: {ROWS}; --cols: {COLS}">
	<div class="debug">

		<span>Hennnn trop sale !</span>
		<h3>
			<!-- <span>aller notre</span>
			<span>
				<a href="https://studiokiss.fr">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.1 8.9" style="enable-background:new 0 0 59.1 8.9" xml:space="preserve"><path d="M1.5 6.7c.2.4.6.7 1.1.7.3 0 .6-.1.6-.4 0-.2-.3-.4-.6-.5l-.7-.1C.8 6 .3 5.4.3 4.6c0-1.1 1.1-1.8 2.3-1.8 1.1 0 1.9.4 2.2 1.2l-1.4.7c-.2-.3-.4-.5-.7-.5-.2 0-.4.1-.4.3 0 .2.2.3.5.4l.7.2c1 .3 1.7.9 1.7 1.9 0 1.2-1.2 2-2.5 2C1.4 8.9.3 8.4 0 7.4l1.5-.7zM8.6 3h1.6v1.6H8.6v4.1h-2V4.6H5.3l2.1-3.4h1.1V3zM14.7 3h1.9v3.4c0 1.6-1.2 2.5-2.9 2.5-1.6 0-2.9-.9-2.9-2.5V3h1.9v3.3c0 .6.4 1 .9 1 .6 0 .9-.4.9-1V3zM20.4 2.8c.7 0 1.4.2 1.8.6V0h1.9v8.8h-1.9v-.6c-.4.5-1.1.7-1.8.7-1.6 0-2.7-1.4-2.7-3.1s1-3 2.7-3zm.5 1.7c-.8 0-1.3.6-1.3 1.4 0 .8.5 1.4 1.3 1.4s1.3-.6 1.3-1.4c0-.8-.5-1.4-1.3-1.4zM26.4 0c.7 0 1.2.5 1.2 1.1 0 .6-.5 1.1-1.2 1.1s-1.2-.5-1.2-1.1c0-.6.5-1.1 1.2-1.1zm.9 3v5.8h-1.9V3h1.9zM31.6 2.8c1.9 0 3.2 1.3 3.2 3.1S33.4 9 31.6 9c-1.9 0-3.2-1.3-3.2-3.1s1.3-3.1 3.2-3.1zm0 1.7c-.8 0-1.3.6-1.3 1.4 0 .8.5 1.4 1.3 1.4s1.3-.6 1.3-1.4c0-.9-.5-1.4-1.3-1.4zM38.2 0h1.9v6.2l2-3.2h2.2l-1.6 2.5 1.9 3.3h-2.2L41 6.3h-.7v2.5h-1.9V0zM46.2 0c.7 0 1.2.5 1.2 1.1 0 .6-.5 1.1-1.2 1.1S45 1.7 45 1.1c.1-.6.6-1.1 1.2-1.1zm1 3v5.8h-1.9V3h1.9zM49.7 6.7c.2.4.6.7 1.1.7.3 0 .6-.1.6-.4 0-.2-.3-.4-.6-.5l-.8-.1c-1.1-.3-1.6-.9-1.6-1.8 0-1.1 1.1-1.8 2.3-1.8 1.1 0 1.9.4 2.2 1.2l-1.5.7c-.1-.3-.4-.4-.7-.4-.2 0-.4.1-.4.3 0 .2.2.3.5.4l.7.2c1.1.2 1.8.8 1.8 1.8 0 1.2-1.2 2-2.5 2s-2.4-.5-2.7-1.5l1.6-.8zM55.4 6.7c.2.4.6.7 1.1.7.3 0 .6-.1.6-.4 0-.2-.3-.4-.6-.5l-.8-.2c-1.1-.3-1.6-.9-1.6-1.8 0-1.1 1.1-1.8 2.3-1.8 1.1 0 1.9.4 2.2 1.2l-1.5.7c-.1-.3-.4-.4-.7-.4-.2 0-.4.1-.4.3 0 .2.2.3.5.4l.7.2c1.2.3 1.9.9 1.9 1.9 0 1.2-1.2 2-2.5 2s-2.4-.5-2.7-1.5l1.5-.8z"/></svg>
				</a>
			</span> -->

			Aller ça suffit, gros bisous.

		</h3>

		<!-- <a href="/" on:keypress={()=>{}} on:click={ () => tuto()}>TUTO</a>	 -->
		<!-- <a href="/" on:keypress={()=>{}} on:click={ () => autoReload()}>recharger</a>	 -->
		<!-- <a href="/" on:keypress={()=>{}} on:click={ e => autoWin(e)}>gagner</a> -->
		<!-- <a href="/" on:keypress={()=>{}} on:click={ e => autoFail(e)}>AUTO FAIL</a>	 -->
		<!-- <a href="/" on:keypress={()=>{}} on:click={ () => reloadAutoWin()}>RELOAD + AUTO WIN</a><br>	 -->
		<!-- <div class="size">{winSize}</div> -->
	</div>
	<Header />

	<div class="indices">
		<h2 class="title-number">Famille {famille}</h2>
		<div class="indice"><b>Indice</b> : {indice}</div>
	</div>
	
	
	<Board
		bind:this={board}
		bind:value={game.board.words}
		tutorial={$settings.tutorial === 1}
		welcome={$settings.welcome === 1}
		on:closeTutPopUp|once={() => {$settings.tutorial = 0; $settings.welcome = 0}}
		board={game.board}
		guesses={game.guesses}
		icon={modeData.modes[$mode].icon}
	/>

	<Keyboard
		on:keystroke={() => {
			if ($settings.tutorial) $settings.tutorial = 0;
			if ($settings.welcome) $settings.welcome = 0;
			board.hideCtx();
		}}
		bind:value={game.board.words[game.guesses === ROWS ? 0 : game.guesses]}
		on:submitWord={submitWord}
		on:esc={() => {
			showTutorial = false;
			showWelcome = false;
			showStats = false;
			showSettings = false;
		}}
		disabled={!game.active || $settings.tutorial === 3 || $settings.welcome === 3}
	/>
</main>

<div class="studiokiss">
	<span>© croixmariebourdon architectes associés — </span>
	<span>
		<a target="_blank" rel="noopener noreferrer" href="https://studiokiss.fr">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.1 8.9" style="enable-background:new 0 0 59.1 8.9" xml:space="preserve"><path d="M1.5 6.7c.2.4.6.7 1.1.7.3 0 .6-.1.6-.4 0-.2-.3-.4-.6-.5l-.7-.1C.8 6 .3 5.4.3 4.6c0-1.1 1.1-1.8 2.3-1.8 1.1 0 1.9.4 2.2 1.2l-1.4.7c-.2-.3-.4-.5-.7-.5-.2 0-.4.1-.4.3 0 .2.2.3.5.4l.7.2c1 .3 1.7.9 1.7 1.9 0 1.2-1.2 2-2.5 2C1.4 8.9.3 8.4 0 7.4l1.5-.7zM8.6 3h1.6v1.6H8.6v4.1h-2V4.6H5.3l2.1-3.4h1.1V3zM14.7 3h1.9v3.4c0 1.6-1.2 2.5-2.9 2.5-1.6 0-2.9-.9-2.9-2.5V3h1.9v3.3c0 .6.4 1 .9 1 .6 0 .9-.4.9-1V3zM20.4 2.8c.7 0 1.4.2 1.8.6V0h1.9v8.8h-1.9v-.6c-.4.5-1.1.7-1.8.7-1.6 0-2.7-1.4-2.7-3.1s1-3 2.7-3zm.5 1.7c-.8 0-1.3.6-1.3 1.4 0 .8.5 1.4 1.3 1.4s1.3-.6 1.3-1.4c0-.8-.5-1.4-1.3-1.4zM26.4 0c.7 0 1.2.5 1.2 1.1 0 .6-.5 1.1-1.2 1.1s-1.2-.5-1.2-1.1c0-.6.5-1.1 1.2-1.1zm.9 3v5.8h-1.9V3h1.9zM31.6 2.8c1.9 0 3.2 1.3 3.2 3.1S33.4 9 31.6 9c-1.9 0-3.2-1.3-3.2-3.1s1.3-3.1 3.2-3.1zm0 1.7c-.8 0-1.3.6-1.3 1.4 0 .8.5 1.4 1.3 1.4s1.3-.6 1.3-1.4c0-.9-.5-1.4-1.3-1.4zM38.2 0h1.9v6.2l2-3.2h2.2l-1.6 2.5 1.9 3.3h-2.2L41 6.3h-.7v2.5h-1.9V0zM46.2 0c.7 0 1.2.5 1.2 1.1 0 .6-.5 1.1-1.2 1.1S45 1.7 45 1.1c.1-.6.6-1.1 1.2-1.1zm1 3v5.8h-1.9V3h1.9zM49.7 6.7c.2.4.6.7 1.1.7.3 0 .6-.1.6-.4 0-.2-.3-.4-.6-.5l-.8-.1c-1.1-.3-1.6-.9-1.6-1.8 0-1.1 1.1-1.8 2.3-1.8 1.1 0 1.9.4 2.2 1.2l-1.5.7c-.1-.3-.4-.4-.7-.4-.2 0-.4.1-.4.3 0 .2.2.3.5.4l.7.2c1.1.2 1.8.8 1.8 1.8 0 1.2-1.2 2-2.5 2s-2.4-.5-2.7-1.5l1.6-.8zM55.4 6.7c.2.4.6.7 1.1.7.3 0 .6-.1.6-.4 0-.2-.3-.4-.6-.5l-.8-.2c-1.1-.3-1.6-.9-1.6-1.8 0-1.1 1.1-1.8 2.3-1.8 1.1 0 1.9.4 2.2 1.2l-1.5.7c-.1-.3-.4-.4-.7-.4-.2 0-.4.1-.4.3 0 .2.2.3.5.4l.7.2c1.2.3 1.9.9 1.9 1.9 0 1.2-1.2 2-2.5 2s-2.4-.5-2.7-1.5l1.5-.8z"/></svg>
		</a>
	</span>
</div>


<Modal
	bind:visible={showTutorial}
	on:close|once={() => $settings.tutorial === 3 && --$settings.tutorial}
	fullscreen={$settings.tutorial === 0}
	classModal="tuto"
>
	<Tutorial visible={showTutorial} />
</Modal>

<Modal
	bind:visible={showWelcome}
	on:close|once={() => $settings.welcome === 3 && --$settings.welcome}
	fullscreen={$settings.welcome === 0}
	classModal="welcome"
>
	<Welcome visible={showWelcome} />
</Modal>







<Modal bind:visible={showStats}>
	{#if modeData.modes[$mode].historical}
		<h2 class="historical">Statistics not available for historical games</h2>
	{:else}
		<Statistics data={stats} />
		<div class="congrat">
			<svg class="desktop" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 310 133.75"><path d="m267.31 31.492 1.679-1.716 4.11 4.02-1.677 1.717zM274.626 38.638l1.678-1.716 4.111 4.02-1.678 1.716zM267.486 41.081l4.019-4.111 1.716 1.677-4.02 4.112zM274.622 33.783l4.02-4.112 1.716 1.678-4.02 4.111zM49.548 45.037l2.358-.448 1.073 5.649-2.357.448zM51.457 55.074l2.358-.448 1.073 5.649-2.357.448zM44.2 53.005l5.648-1.075.449 2.358-5.649 1.075zM54.226 51.094l5.649-1.074.448 2.357-5.649 1.075zM28.63 102.9c-.32-.96-1.04-1.68-2-2.08-.88-.4-1.92-.48-2.88-.08-.96.32-1.68 1.04-2.08 2-.88 1.92 0 4.07 1.84 4.95.48.24 1.04.32 1.52.32 1.44 0 2.8-.8 3.43-2.24.48-.96.56-2 .16-2.88Zm-2.24 1.84c-.32.64-1.12.96-1.76.64-.64-.32-.96-1.12-.64-1.76.16-.32.4-.56.72-.72.16-.08.32-.08.48-.08s.4 0 .56.08c.32.16.56.4.72.72.08.48.08.8-.08 1.12M228.36 47.7c-2.72-1.2-5.99 0-7.19 2.72-1.2 2.72 0 5.99 2.72 7.19.72.32 1.44.48 2.24.48.64 0 1.28-.08 1.92-.32 1.36-.48 2.4-1.52 3.04-2.88 1.2-2.72 0-5.99-2.72-7.19m.48 6.2c-.32.72-.96 1.28-1.68 1.6-.72.32-1.6.24-2.32-.08-1.52-.72-2.24-2.48-1.52-3.99.48-1.12 1.6-1.76 2.8-1.76.4 0 .88.08 1.28.24 1.44.64 2.16 2.48 1.44 3.99ZM80.674 91.436l1.903-4.22 2.188.986-1.903 4.22zM77.314 98.911l1.904-4.22 2.188.987-1.905 4.22zM74.696 92.028l.987-2.188 4.22 1.905-.987 2.187zM82.241 95.42l.988-2.187 4.22 1.905-.987 2.187zM172.09 66.24l4.96-11.04 2.32-5.2 1.2-2.72 2.16.96c.16.08.32.08.48.08.24 0 .56-.08.72-.24.32-.24.48-.56.48-.96v-.24l-3.92-22.71c-.08-.4-.32-.72-.72-.88-.4-.16-.8-.16-1.12.08l-19.43 12.15c-.32.24-.56.64-.56 1.04v.08c0 .48.32.8.72 1.04l2.16.96-14.55 32.07c-.24.64 0 1.28.64 1.6l4.16 1.84-12.72 28.15 2.16.96 12.71-28.15 2.72 1.28c-.64 1.76-1.36 5.44.56 9.28l2.16-1.12c-1.52-2.96-.96-5.76-.48-7.2l5.76 2.56c.16.08.32.08.48.08s.32 0 .4-.08c.32-.08.56-.32.64-.64l5.36-11.84.56-1.2Zm6.5-39.79 3.28 18.7-19.41-8.79 16.14-9.91Zm-8.87 39.31-16.86-2.08 1.52-3.36 16.86 2.08-1.52 3.36Zm-14.3-7.67 2-4.39 16.86 2.08-2 4.39-16.86-2.08Zm4.23-9.51.24-.56 16.86 2.08-1.52 3.36-16.86-2.08 1.28-2.8Zm18.22-.8-16.94-2.08 2.72-6.07 14.78 6.71-.56 1.44Zm-13.34 29.48-14.78-6.71 2.08-4.63 16.86 2.16-4.15 9.19ZM146.381 31.833l2.367-5.24 2.187.987-2.366 5.24zM142.178 41.142l2.366-5.24 2.188.987-2.366 5.24zM138.797 32.223l.987-2.188 5.24 2.365-.987 2.188zM148.119 36.415l.987-2.187 5.24 2.365-.986 2.188zM178.747 79.464l1.903-4.22 2.188.986-1.904 4.22zM175.389 86.95l1.905-4.22 2.187.987-1.905 4.22zM172.794 80.061l.988-2.187 4.22 1.904-.987 2.188zM180.34 83.444l.987-2.187 4.22 1.904-.987 2.188zM199.92 35.96c-.32-.96-1.04-1.68-2-2.08-.88-.4-1.92-.48-2.88-.08-.96.32-1.68 1.04-2.08 2-.88 1.92 0 4.07 1.84 4.95.48.24 1.04.32 1.52.32 1.44 0 2.8-.8 3.43-2.24.48-.96.56-2 .16-2.88Zm-2.24 1.84c-.32.64-1.12.96-1.76.64-.64-.32-.96-1.12-.64-1.76.16-.32.4-.56.72-.72.16-.08.32-.08.48-.08s.4 0 .56.08c.32.16.56.4.72.72.08.48.08.8-.08 1.12M136.08 68.16c-2.72-1.2-5.99 0-7.19 2.72-1.2 2.72 0 5.99 2.72 7.19.72.32 1.44.48 2.24.48.64 0 1.28-.08 1.92-.32 1.36-.48 2.4-1.52 3.04-2.88 1.2-2.72 0-5.99-2.72-7.19m.48 6.2c-.32.72-.96 1.28-1.68 1.6-.72.32-1.6.24-2.32-.08-1.52-.72-2.24-2.48-1.52-3.99.48-1.12 1.6-1.76 2.8-1.76.4 0 .88.08 1.28.24 1.44.64 2.16 2.48 1.44 3.99Z"/></svg>
			<svg class="mobile" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 133.75"><path d="m117.74 74.51 4.96-11.04 2.32-5.2 1.2-2.72 2.16.96c.16.08.32.08.48.08.24 0 .56-.08.72-.24.32-.24.48-.56.48-.96v-.24l-3.92-22.71c-.08-.4-.32-.72-.72-.88-.4-.16-.8-.16-1.12.08l-19.43 12.15c-.32.24-.56.64-.56 1.04v.08c0 .48.32.8.72 1.04l2.16.96-14.55 32.07c-.24.64 0 1.28.64 1.6l4.16 1.84-12.72 28.15 2.16.96 12.71-28.15 2.72 1.28c-.64 1.76-1.36 5.44.56 9.28l2.16-1.12c-1.52-2.96-.96-5.76-.48-7.2l5.76 2.56c.16.08.32.08.48.08s.32 0 .4-.08c.32-.08.56-.32.64-.64l5.36-11.84.56-1.2Zm6.5-39.79 3.28 18.7-19.41-8.79 16.14-9.91Zm-8.87 39.31-16.86-2.08 1.52-3.36 16.86 2.08-1.52 3.36Zm-14.3-7.67 2-4.39 16.86 2.08-2 4.39-16.86-2.08Zm4.23-9.51.24-.56 16.86 2.08-1.52 3.36-16.86-2.08 1.28-2.8Zm18.22-.8-16.94-2.08 2.72-6.07 14.78 6.71-.56 1.44Zm-13.34 29.48L95.4 78.82l2.08-4.63 16.86 2.16-4.15 9.19ZM92.024 40.097l2.366-5.24 2.187.987-2.366 5.24zM87.83 49.41l2.366-5.24 2.187.987-2.366 5.24zM84.451 40.484l.988-2.188 5.24 2.366-.987 2.187zM93.77 44.686l.987-2.188 5.24 2.366-.987 2.187zM124.397 87.726l1.903-4.22 2.188.986-1.903 4.22zM121.04 95.22l1.904-4.22 2.188.988-1.905 4.22zM118.436 88.318l.987-2.188 4.22 1.905-.987 2.187zM125.982 91.71l.987-2.187 4.22 1.905-.987 2.187zM145.57 44.22c-.32-.96-1.04-1.68-2-2.08-.88-.4-1.92-.48-2.88-.08-.96.32-1.68 1.04-2.08 2-.88 1.92 0 4.07 1.84 4.95.48.24 1.04.32 1.52.32 1.44 0 2.8-.8 3.43-2.24.48-.96.56-2 .16-2.88Zm-2.24 1.84c-.32.64-1.12.96-1.76.64-.64-.32-.96-1.12-.64-1.76.16-.32.4-.56.72-.72.16-.08.32-.08.48-.08s.4 0 .56.08c.32.16.56.4.72.72.08.48.08.8-.08 1.12M81.73 76.42c-2.72-1.2-5.99 0-7.19 2.72-1.2 2.72 0 5.99 2.72 7.19.72.32 1.44.48 2.24.48.64 0 1.28-.08 1.92-.32 1.36-.48 2.4-1.52 3.04-2.88 1.2-2.72 0-5.99-2.72-7.19m.48 6.2c-.32.72-.96 1.28-1.68 1.6-.72.32-1.6.24-2.32-.08-1.52-.72-2.24-2.48-1.52-3.99.48-1.12 1.6-1.76 2.8-1.76.4 0 .88.08 1.28.24 1.44.64 2.16 2.48 1.44 3.99ZM34.332 42.295l2.358-.448 1.074 5.649-2.358.448zM36.251 52.322l2.358-.448 1.073 5.649-2.357.448zM28.994 50.256l5.648-1.075.449 2.358-5.649 1.074zM39.02 48.345l5.649-1.075.448 2.358-5.648 1.075zM169.39 64.96c-2.72-1.2-5.99 0-7.19 2.72-1.2 2.72 0 5.99 2.72 7.19.72.32 1.44.48 2.24.48.64 0 1.28-.08 1.92-.32 1.36-.48 2.4-1.52 3.04-2.88 1.2-2.72 0-5.99-2.72-7.19m.48 6.2c-.32.72-.96 1.28-1.68 1.6-.72.32-1.6.24-2.32-.08-1.52-.72-2.24-2.48-1.52-3.99.48-1.12 1.6-1.76 2.8-1.76.4 0 .88.08 1.28.24 1.44.64 2.16 2.48 1.44 3.99Z"/></svg>
		</div>

	{/if}

	{#if !game.active}
		<Definition {word} />
	{/if}


	<div class="separator" visible={!game.active}>

		<div class="linkproject reload">
			<a href="./" on:keypress={()=>{}} on:click={() => reload()}>
				<div class="button">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137 133.75"><path d="M71 29.81c-2.16.04-4.34.29-6.52.74C47.23 34.15 35.1 49.88 35.6 67.7l-2.25-2.29c-.53-.55-1.26-.87-2.02-.88-.76 0-1.49.29-2.03.82-.54.53-.84 1.26-.84 2.02s.3 1.48.84 2.02l6.63 6.74c.52.85 1.44 1.37 2.44 1.37h.07c1 0 1.94-.52 2.45-1.38l6.62-6.73c.55-.54.85-1.28.84-2.05 0-.77-.33-1.5-.88-2.03-.56-.53-1.31-.81-2.08-.78-.73.03-1.43.35-1.93.88l-2.2 2.24c-.48-15.21 9.81-28.52 24.37-31.55 14.7-3.06 29.36 5.21 34.64 19.63 5.28 14.42-.51 30.59-13.6 38.12-13.08 7.54-29.5 4.24-38.84-7.81-.62-.8-1.62-1.21-2.63-1.07-1 .13-1.86.8-2.24 1.73-.39.94-.24 2.01.38 2.81 11.02 14.22 30.68 18.17 46.17 9.25 15.5-8.92 22.3-28.01 16.09-44.98-4.65-12.72-15.65-21.48-28.21-23.52-2.09-.34-4.24-.49-6.39-.45Z"/></svg>
				</div>
				<h3>Rejouer !</h3>
			</a>	
		</div>	

		<div class="linkproject">
			<a target="_blank" rel="noopener noreferrer" href="{projectLink}">
				<div class="button">
					<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 137 133.8" viewBox="0 0 137 133.8"><path d="m74 46 1.6-.2c.9-.1 1.7.5 1.8 1.4l1.8 14.6c.1.9-.5 1.7-1.4 1.8l-34 4.2c-.9.1-1.7-.5-1.9-1.3v-.1l-1.8-14.6c-.1-.8.5-1.7 1.4-1.8l1.6-.2-.6-4.8c-.1-.9.5-1.7 1.4-1.8l9.7-1.2c.9-.1 1.7.5 1.8 1.4l.6 4.9 4.9-.6-.6-4.9c-.1-.9.5-1.7 1.4-1.8l9.7-1.2c.9-.1 1.7.5 1.8 1.4L74 46zm-30.5 7 1.4 11.4 30.8-3.8-1.4-11.3L43.5 53zm2.9-3.6 6.5-.8-.4-3.2-6.5.8.4 3.2zM63.8 44l.4 3.2 6.5-.8-.4-3.2-6.5.8zm15.9 33.3v-4.9c0-.9.7-1.6 1.6-1.6h9.8c.9 0 1.6.7 1.6 1.6v4.9h1.6c.9 0 1.6.7 1.6 1.6v14.7c0 .9-.7 1.6-1.6 1.6H42.1c-.9 0-1.6-.7-1.6-1.6V79c0-.9.7-1.6 1.6-1.6h1.6v-4.9c0-.9.7-1.6 1.6-1.6h9.8c.9 0 1.6.7 1.6 1.6v4.9h4.9v-4.9c0-.9.7-1.6 1.6-1.6H73c.9 0 1.6.7 1.6 1.6v4.9l5.1-.1zm-36 3.3V92h49V80.6h-49zM47 74v3.3h6.5V74H47zm18 0v3.3h6.5V74H65zm18 0v3.3h6.5V74H83z"/></svg>
				</div>
				<h3>Voir le projet</h3>
			</a>	
		</div>	
		<div class="linkproject">
			<a target="_blank" rel="noopener noreferrer" href="https://www.croixmariebourdon.fr" class="website">

				<div class="button">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137 133.75"><path d="M57.59 41.06h-1.35c-14.65 0-26.56 11.55-26.56 25.76S41.6 92.57 56.24 92.57h1.35V41.06ZM33.83 58.88c3.2-8.47 11.36-14.64 21.06-15.17v15.17H33.83Zm21.06 31.03c-12.53-.68-22.51-10.78-22.51-23.1 0-1.83.23-3.61.64-5.32h21.87v28.42ZM87.42 40.95H61.57v52.06h25.85c9.7 0 17.58-7.65 17.58-17.05 0-3.29-.98-6.35-2.65-8.96 1.67-2.62 2.65-5.69 2.65-8.99 0-9.41-7.89-17.06-17.58-17.06m13.18 23.77c-3.2-3.53-7.88-5.78-13.09-5.81l-23.24-.03V43.56h23.15c8.21 0 14.89 6.47 14.89 14.44 0 2.42-.62 4.7-1.7 6.71M64.28 72.5v-11l23.15.02c4.72 0 8.92 2.15 11.65 5.48-2.73 3.35-6.93 5.5-11.65 5.5H64.28Zm24.49 17.83V75.05c4.71-.35 8.9-2.51 11.84-5.77 1.08 2 1.7 4.26 1.7 6.67 0 7.52-5.96 13.71-13.54 14.38M64.28 75.11h21.8v15.27h-21.8V75.11Z"/></svg>
				</div>
				<h3>Voir notre site</h3>			
			</a>	
		</div>

	</div>
</Modal>



<style lang="scss">
	.studiokiss{
		position: absolute;
		z-index: 1;
		right: 1rem;
		bottom: 1rem;

		opacity: 0.7;
		color: #000;
		transition: 0.2s opacity;
		a, span{
			text-decoration: none;
			font-size: 0.7rem;
		}
		svg{
			width: 3.2rem;
			height: auto;
		}
		&:hover{
			opacity: 1;
		}
		display: none;
		@media (min-width: 1145px){  
			display: block;
		}

	}
	.debug{
		// display: none;

		position: fixed;
		right: 0;
		bottom: 0;
		background-color: #000;
		color: #fff;
		z-index: 9999;
		padding: 1rem ;
		border-top-left-radius: 30px;
		text-align: right;
		opacity: 0;
		transform: translateX(110%);

		pointer-events: none;

		transition: 0.4s transform cubic-bezier(0.075, 0.82, 0.165, 1);
		// a{
		// 	display: inline-block;
		// 	border:1px solid #fff;
		// 	padding: 0.5rem 1rem;
		// 	border-radius: 10px;

		// 	cursor: pointer;
		// 	text-decoration: none;

		// 	transition: 0.3s all cubic-bezier(0.075, 0.82, 0.165, 1);

		// 	&:hover{
		// 		background-color: #fff;
		// 		color: #000;
		// 	}
		// }
		*{
			font-size: 0.8rem;
		}
		// svg{
		// 	width: 5rem;
		// 	height: auto;
		// 	path{
		// 		fill: #fff;
		// 	}
		// }
		h3{
			text-transform: none;
			font-size: 0.6rem;
			margin-bottom: 0;
		}
		span{
			// display: inline-block;
			margin-bottom: 0.2rem;
			display: block;
		}
	}



	main {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;

		max-width: var(--game-width);
		margin: auto;

		height: 100%;
		position: relative;
		background-color: var(--blue);
		border-radius: 10px;

		@media (max-width: 500px) {  
			border-radius: 0;
			width: 100%;

		}

		@media (min-width: 500px) {  
			padding:1rem;
		}

		max-height: 1000px;

	}
	.historical {
		text-align: center;
		margin-top: 10px;
		padding: 0 20px;
		text-transform: uppercase;
	}

	.indices{
		width: 100%;
		padding: 10px 50px;
		font-size: 0.9rem;
		text-align: center;
		color: #fff;

		

		@media (max-width: 500px) {  
			font-size: 0.7rem;
			padding: 8px;

			padding: 8px 50px;


		}


		h2{
			margin-bottom: 0.5rem;
			text-transform: uppercase;

			@media (max-width: 500px) {  
				font-size: 0.9rem;
				margin-bottom: 0.2rem;
			}

		}

	}



	.separator{
		display: flex;
		flex-direction: row;
		justify-content: center;
		gap: 1rem;
	}

	.separator .button {
		height:100px;
		aspect-ratio: 1;
		cursor: pointer;
		margin: auto;
	}
	@media (min-width: 499px) and (max-height:900px) {  
		.separator .button {
			height:60px;
		}
		.separator svg{
			width: 100%;
			height: 100%;
			
		}

	}


	.linkproject{
		width: 17%;
		transition: opacity 0.2s;
	}

	h3{
		font-size: 0.8rem;
	}

	.congrat{
		svg.desktop{
			margin:0 auto;
			max-width: 600px;
		}
	}


	@media (max-width: 499px) {  
		.separator .button {
			height:50px;
		}
		.linkproject{
			width: 27%;
		}

		h3{
			font-size: 0.7rem;
		}

	}

	.separator svg {
		fill: #000;
		height: 100%;
	}

	.linkproject:hover{
		opacity: 0.5;
	}
	.reload{
		color: var(--blue);
		svg{
			fill: var(--blue);
		}
	}

	.separator a{
		text-decoration: none;
	}






	@media (max-width: 500px) {  
		.mobile{
			display: block;
		}
		.desktop{
			display: none;
		}
	}
	@media (min-width: 500px) {  
		.mobile{
			display: none;
		}
		.desktop{
			display: block;
		}
	}
</style>
